import { apiFetch, type AjaxResult } from './http';

export type WalletSummary = {
  balance: number;
  frozen: number;
  totalRecharge: number;
  totalSpent: number;
  totalCommission: number;
};

export type WalletTransaction = {
  txnId: number;
  txnNo: string;
  txnType: string;
  bizType?: string;
  bizId?: number;
  amount: number;
  description: string;
  status: string;
  createTime: string;
};

export type PaymentBinding = {
  usdtAddress: string;
  bankAccountName: string;
  bankName: string;
  bankCardNo: string;
  bankBranch: string;
};

export async function fetchWalletSummary(): Promise<AjaxResult<WalletSummary>> {
  return apiFetch('/api/app/wallet/summary', { method: 'GET', auth: true });
}

export async function fetchWalletTransactions(type?: string): Promise<AjaxResult<WalletTransaction[]>> {
  const query = type ? `?type=${encodeURIComponent(type)}` : '';
  return apiFetch(`/api/app/wallet/transactions${query}`, { method: 'GET', auth: true });
}

export type RechargeOrder = {
  applyNo: string;
  amount: string;
  payAmount: string;
  address: string;
  status: string;
  expireTime: string;
  expireAt: number | null;
};

export async function fetchRechargeAddress(): Promise<AjaxResult<{ address: string }>> {
  return apiFetch('/api/app/wallet/recharge/address', { method: 'GET', auth: true });
}

export async function applyRecharge(amount: number): Promise<AjaxResult<RechargeOrder>> {
  return apiFetch('/api/app/wallet/recharge/apply', {
    method: 'POST',
    auth: true,
    body: JSON.stringify({ amount }),
  });
}

export async function fetchCurrentRecharge(): Promise<AjaxResult<RechargeOrder | null>> {
  return apiFetch('/api/app/wallet/recharge/apply/current', { method: 'GET', auth: true });
}

export async function fetchRechargeStatus(applyNo: string): Promise<AjaxResult<RechargeOrder>> {
  return apiFetch(`/api/app/wallet/recharge/apply/status?applyNo=${encodeURIComponent(applyNo)}`, {
    method: 'GET',
    auth: true,
  });
}

export async function fetchPaymentBinding(): Promise<AjaxResult<PaymentBinding>> {
  return apiFetch('/api/app/wallet/payment-binding', { method: 'GET', auth: true });
}

export async function savePaymentBinding(body: PaymentBinding): Promise<AjaxResult<unknown>> {
  return apiFetch('/api/app/wallet/payment-binding', {
    method: 'POST',
    auth: true,
    body: JSON.stringify(body),
  });
}

export async function applyWithdraw(amount: number, remark = ''): Promise<AjaxResult<{ applyNo: string }>> {
  return apiFetch('/api/app/wallet/withdraw/apply', {
    method: 'POST',
    auth: true,
    body: JSON.stringify({ amount, remark }),
  });
}
